import React, { useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import { useToast } from '../../Components/CommonToast';
import { create_support_request } from '../../services';
import SupportRequestForm from './forms/SupportRequestForm';
import './Support.css';

// ═══════════════════════════════════════════════════════════════
// Support — module entry point. App-wide, open to every signed-in user.
// ---------------------------------------------------------------
// A single screen: the user picks Bug or Feature, describes it and optionally
// attaches files. It all goes to the backend as one multipart request, and the
// backend emails it to the accountable support contact (the recipient address
// lives server-side, not here).
// ═══════════════════════════════════════════════════════════════
export default function Support() {
    const [saving, setSaving] = useState(false);
    const [submitError, setSubmitError] = useState('');
    // Bumped after a successful submit to remount (and so reset) the form.
    const [formKey, setFormKey] = useState(0);
    const { notify, toastNode } = useToast();

    const handleSubmit = async (values, files) => {
        setSaving(true);
        setSubmitError('');
        try {
            const fd = new FormData();
            fd.append('request_type', values.request_type);
            fd.append('description', values.description.trim());
            files.forEach((file) => fd.append('files', file));

            const res = await create_support_request(fd);
            // ApiIntercepter resolves (not rejects) when the body carries an error.
            if (res?.errors) throw new Error(res.errors.message || 'Failed to submit request');

            notify('Request submitted — our team has been notified', 'success');
            setFormKey((k) => k + 1);
        } catch (e) {
            const msg = e?.response?.data?.error?.message || e?.message || 'Failed to submit request';
            setSubmitError(msg);
            notify(msg, 'error');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="cmn_elevated_card p-3 support_page">
            <PageHeading className="support_heading" title="Support"subtitle="Report a bug or request a feature." />

            <div className="support_form">
                <SupportRequestForm key={formKey} onSubmit={handleSubmit} saving={saving} error={submitError} />
            </div>

            {toastNode}
        </div>
    );
}
